import mock from '../mock'

const utilities = {
  turiaworkspace: {
    id: 1,
    name: 'Clients',
    folderName: 'Client'
  }, 
  serviceTemplates: {
    id: 1,
    name: 'Service Templates',
    folderName: 'Services'
  }, 
  teamDocuments: {
    id: 1,
    name: 'Team Documents',
    folderName: 'Team'
  }, 
  recents: {
    id: 1,
    name: 'Recent Activity',
    folderName: 'Recents'
  } 
}

mock.onPost('/api/files/workspace/dropdown').reply(200, utilities)